function isURLInternal() {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator

  return pattern
}

function isValidURL(str){
  let pattern = isURLInternal();
  return pattern.test(str);
  
}
function getYouTubeVideoId(url) {
  const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  const matches = `${url}`.match(p);
  if (matches) {
    return matches[1];
  }
  return false;
}
function parseYouTubeVideoURL(url) {
  const videoId = getYouTubeVideoId(url);
  return `https://www.youtube.com/embed/${videoId}`;
}
export { isValidURL, getYouTubeVideoId, parseYouTubeVideoURL };
